import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\AddWikiItemsToModelController::__invoke
* @see app/Http/Controllers/Dossier/AddWikiItemsToModelController.php
* @route '/api/dossier/{modelType}/model/{modelId}/add-wiki-items'
*/
const AddWikiItemsToModelController = (args: { modelType: string | number, modelId: string | number } | [modelType: string | number, modelId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddWikiItemsToModelController.url(args, options),
    method: 'post',
})

AddWikiItemsToModelController.definition = {
    methods: ["post"],
    url: '/api/dossier/{modelType}/model/{modelId}/add-wiki-items',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\AddWikiItemsToModelController::__invoke
* @see app/Http/Controllers/Dossier/AddWikiItemsToModelController.php
* @route '/api/dossier/{modelType}/model/{modelId}/add-wiki-items'
*/
AddWikiItemsToModelController.url = (args: { modelType: string | number, modelId: string | number } | [modelType: string | number, modelId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            modelType: args[0],
            modelId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        modelType: args.modelType,
        modelId: args.modelId,
    }

    return AddWikiItemsToModelController.definition.url
            .replace('{modelType}', parsedArgs.modelType.toString())
            .replace('{modelId}', parsedArgs.modelId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\AddWikiItemsToModelController::__invoke
* @see app/Http/Controllers/Dossier/AddWikiItemsToModelController.php
* @route '/api/dossier/{modelType}/model/{modelId}/add-wiki-items'
*/
AddWikiItemsToModelController.post = (args: { modelType: string | number, modelId: string | number } | [modelType: string | number, modelId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddWikiItemsToModelController.url(args, options),
    method: 'post',
})

export default AddWikiItemsToModelController